// extracted by mini-css-extract-plugin
export default {"lds-spinner":"styles_lds-spinner__hstVo"};